/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2018, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS 'AS IS' AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import React from 'react'
import PropTypes from 'prop-types'

import {
  Button,
  SvgIcon,
  ExpandableOverviewItem,
  WorkflowRunSteps
} from '../'


export class RequestWorkflow extends React.Component {
  static propTypes = {
    requestRun: PropTypes.shape({
      id: PropTypes.string,
      sources: PropTypes.array,
      requesttype: PropTypes.object,
      isCaptured: PropTypes.bool,
      capturedBy: PropTypes.object,
      validatedBy: PropTypes.object,
      status: PropTypes.string,
      workflowrunProcessing: PropTypes.object
    }),
    open: PropTypes.bool,
    initiateWorkflowRun: PropTypes.func,
    captureRequired: PropTypes.bool,
    onClick: PropTypes.func,
    className: PropTypes.string,
    singleItemCondensedView: PropTypes.bool,
    onRefreshClick: PropTypes.func.isRequired
  }

  state = {
    initiateInProgress: false
  }

  render() {
    let { requestRun, open, captureRequired, onClick, initiateWorkflowRun, singleItemCondensedView, onRefreshClick, className } = this.props
    let workflowInitiated = requestRun.workflowrunProcessing

    return (
      <ExpandableOverviewItem
        title='Workflow'
        iconSymbol={workflowInitiated ? 'check' : null}
        iconColour={workflowInitiated ? 'success' : null}
        open={open}
        locked={(captureRequired && !requestRun.isCaptured) ||
          (requestRun.validationRequired && !requestRun.isValidated)
        }
        onClick={onClick}
        summary={
          <div className='slds-truncate'>
            {requestRun.workflowrunProcessing
              ? `${requestRun.workflowrunProcessing.workflow.name}`
              : ''
            }
          </div>
        }
        className={className}
        singleItemCondensedView={singleItemCondensedView}>
        {workflowInitiated
          ? <React.Fragment>
              <div className='slds-grid slds-m-bottom_large'>
                <div>
                  <SvgIcon
                    variant='utility'
                    symbol='check'
                    colour='success'
                    className='slds-m-right_medium'
                  />
                </div>
                <div className='u-font-size-large'>
                  {`${requestRun.workflowrunProcessing.workflow.name} workflow successfully initiated.`}
                </div>
              </div>
              <WorkflowRunSteps
                workflowRunId={requestRun.workflowrunProcessing.id}
                hideActionButtons={true}
                preventClickThrough={true}
                onRefreshClick={onRefreshClick}
                noStepExpand={true}
                className='slds-m-bottom_medium'
              />
            </React.Fragment>
          : <div className='slds-m-around_large'>
              <Button
                type='brand'
                minWidth={150}
                disabled={this.state.initiateInProgress}
                onClick={() => {
                  this.setState(
                    { initiateInProgress: true },
                    () => initiateWorkflowRun(requestRun.requesttype.workflow.id, requestRun.version, requestRun.requesttype.name, `${requestRun.identity.firstName} ${requestRun.identity.lastName}`)
                      .then(() => this.setState({ initiateInProgress: false }))
                      .catch(() => this.setState({ initiateInProgress: false }))
                  )}}>
                {this.state.initiateInProgress
                  ? 'Initiating...'
                  : 'Initiate workflow'
                }
              </Button>
            </div>
        }
      </ExpandableOverviewItem>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/request-workflow/index.js